import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAPIKeyGenerateKeyMutation } from '@/hook/apiKey';
import { VFlex, VIconButton, VModal, VStack } from '@/package';
import { Close } from '@/package';

import { APIKeyForm } from './APIKeyForm';

type APIKeyCreationModalProps = {
  visible: boolean;
  onHide?(): void;
  onShow?(): void;
};

export const APIKeyCreationModal = ({
  visible,
  onHide,
  onShow,
}: APIKeyCreationModalProps) => {
  const { t } = useTranslation();
  const { mutateAsync: generateKey } = useAPIKeyGenerateKeyMutation();
  const [secretKey, setSecretKey] = useState('');

  useEffect(() => {
    if (!visible) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setSecretKey('');
      return;
    }

    generateKey().then(res => setSecretKey(res.data.resultData));
  }, [visible]);

  return (
    <VModal
      initialZIndex={2900}
      visible={visible}
      onUpdateVisible={visible => (visible ? onShow?.() : onHide?.())}
    >
      <VFlex className="-mt-4 h-10 py-2" justify="between" items="center">
        <div>{t('apiKey.createButtonText.twigsome')}</div>
        <VIconButton
          Icon={Close}
          size="sm"
          variant="roundPrimary"
          onClick={onHide}
        />
      </VFlex>

      <VStack className="pt-2.5" gap={0.625}>
        <div>
          <div className="text-body-xl">
            {t('apiKey.createModalDescription.pteridospermae')}
          </div>
          <div className="mt-1 pl-1 text-body-lg whitespace-pre-line text-gray-600">
            {t('apiKey.createModalSubDescription.meadowwort')}
          </div>
        </div>
        <APIKeyForm
          formDefaultValue={{
            apiKey: secretKey,
            createdAt: '',
            expireAt: dayjs().add(30, 'days').toISOString(),
            id: 0,
            name: '',
            status: 'Enable',
          }}
          isEditablePermission
          onSubmitted={onHide}
        />
      </VStack>
    </VModal>
  );
};

APIKeyCreationModal.displayName = 'APIKeyCreationModal';
